import { sanitizeLegacyAppAccessToken, sanitizeLegacyPersistedState } from './legacyQuerySanitizer';

// Imported first from index.tsx so it runs before React, MSAL, telemetry, or routing read the URL or stored state.
sanitizeLegacyAppAccessToken();
sanitizeLegacyPersistedState();
